import withdrawService from '@/store/services/withdrawService'

const state = {
  field: {
    amount: null,
    partner_id: null,
    status: null,
    paginate: 10,
  },
  metaWithdraw: null,
  withdraw: null,
  partner_field: null,
  refreshWithdrawCount: 0,
}

const getters = {
  withdraws: state => (state.metaWithdraw ? state.metaWithdraw.data : []),
  current_page: state => (state.metaWithdraw ? state.metaWithdraw.current_page : 0),
  last_page: state => (state.metaWithdraw ? state.metaWithdraw.last_page : 0),
  per_page: state => (state.metaWithdraw ? state.metaWithdraw.per_page : 0),
  total: state => (state.metaWithdraw ? state.metaWithdraw.total : 0),
}

const actions = {
  getWithdrawalsList({ commit, state }, { page, field }) {
    if (state.metaWithdraw && state.metaWithdraw.current_page === page
        && state.partner_field === field.partner_id) return state.metaWithdraw

    return withdrawService.getWithdrawals(page, field).then(({ data }) => {
      commit('SET_META_WITHDRAW', data.result)
      commit('SET_PARTNER_FIELD', field.partner_id)
      commit('SET_FIELD', field)
      return data
    })
  },
  getWithdrawalById({ commit }, id) {
    return withdrawService.getWithdrawal(id).then(({ data }) => {
      commit('SET_WITHDRAW', data.result)
      return data
    })
  },

  validateWithdrawal({ commit }, id) {
    return withdrawService.validateWithdrawal(id).then(({ data }) => {
      // Optimistically update or just resolve, the component will likely refresh the list
      return data
    })
  },
  verifyStatus({ commit }, id) {
    return withdrawService.verifyWithdrawalStatus(id).then(({ data }) => {
      return data
    })
  },
}

const mutations = {
  SET_META_WITHDRAW(state, metaWithdraw) {
    state.metaWithdraw = metaWithdraw
  },
  SET_PARTNER_FIELD(state, partner_id) {
    state.partner_field = partner_id
  },
  SET_WITHDRAW(state, withdraw) {
    state.withdraw = withdraw
  },
  SET_FIELD(state, field) {
    state.field = field
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}

